import React, { useEffect } from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Scrollbar from './components/ScrollBar';
import { hydrate } from "react-dom";
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';


const tagManagerArgs = {
    gtmId: 'GTM-NZ9VKW6W'
}

const disableGTM = false;

const GtmInit = () =>{
  useEffect(() => {
    if(window.location.hostname !== 'localhost' && !disableGTM){
      TagManager.initialize(tagManagerArgs);
    }
  },[]);

  return null;
}


const rootElement = document.getElementById("root");
const root = createRoot(rootElement); 


if (rootElement.hasChildNodes()) {
  hydrate(  
  <React.StrictMode>
    <Scrollbar/>
    <App />
    <GtmInit/>
  </React.StrictMode>, rootElement);
} else {
  root.render(  
  <React.StrictMode>
    <Scrollbar/>
    <App />
    <GtmInit/>
  </React.StrictMode>);
}

reportWebVitals();
